import jwt_decode from 'jwt-decode';

export interface JWTToken {
  exp: number;
  iat: number;
  scope: string;
  uid: number;
  error?: string;
}

const memo: Record<string, JWTToken> = {};

export const decodeToken = (token: string): JWTToken => {
  const decoded = memo[token] || jwt_decode(token);

  const now: number = new Date().getTime() / 1e3;
  if (decoded.exp < now) {
    decoded.error = 'Expired';
  }

  memo[token] = decoded;

  return decoded;
};
